import type {
  KyrgyzstanOwnerModerationDraft,
  KyrgyzstanOwnerRealtyObject,
} from 'shared/api/kyrgyzstan/webview-owner'

import type { MyObject, MyObjectStatus } from '../model/types'

const ACTIVE_OBJECT_STATUS_LABEL = 'Активно'

export const mapOwnerRealtyObjectToMyObject = (
  realtyObject: KyrgyzstanOwnerRealtyObject,
): MyObject => ({
  id: realtyObject.id,
  title: realtyObject.title,
  address: realtyObject.address,
  price: Number.parseFloat(realtyObject.price) || 0,
  status: 'active',
  statusLabel: ACTIVE_OBJECT_STATUS_LABEL,
  rejectionReason: null,
  moderationStatus: null,
})

export const mapOwnerModerationDraftToMyObject = (
  draft: KyrgyzstanOwnerModerationDraft,
  status: Exclude<MyObjectStatus, 'active'>,
): MyObject => ({
  id: draft.id,
  title: draft.title,
  address: draft.full_address,
  price: Number.parseFloat(draft.price) || 0,
  status,
  statusLabel: draft.status_label,
  rejectionReason: draft.rejection_reason,
  moderationStatus: draft.moderation_status,
})
